export default {"src":"/_next/static/image/public/images/add_profile.47615537f9b811edb424d087965dba07.svg","height":36,"width":36};